import { render, staticRenderFns } from "./booking-detail.vue?vue&type=template&id=2dcc8047&scoped=true"
import script from "./booking-detail.vue?vue&type=script&lang=js"
export * from "./booking-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcc8047",
  null
  
)

export default component.exports